import "./features/print.ts";
import * as amplify from "./util/amplify.ts";
import * as libLocation from "./lib/location.ts";
import * as modal from "./util/modal.ts";
import * as i18n from "./i18n.ts";
import * as FwDatas from "./FwDatas.ts";
import ApiServer from "./ApiServer.ts";
import MultiplexApi from "./server/MultiplexApi.ts";

import FizConfig from "./FizConfig.ts";
import * as multifamily from "./features/multifamily.ts";
import * as login from "./features/login.ts";
import * as Html from "./util/Html.ts";
import * as calendar_modal from "./calendar/calendar_modal.ts";
import * as renderurl from "./text-renderurl.ts";
import * as Handlebars from "./handlebars_family.ts";
import * as actionMenu from "./widget/action-menu-registry.ts"
import { quantityPicker } from "./widget/action-menu-content.ts";
import { formatQuantityUnit } from "./lib/unitFormat.ts";

import {OS} from "./lib/os.ts"
import * as segment from "./tracking-segment.ts";
import Icons from "./svg/Icons.ts"

import "./features/invite.ts";
import "./filer/fileViewer.ts";
import "./contact/contacts_common.ts";
import "./form/multifile.ts";
import "./mealplanner/mealplannerModal.ts"

import { TaskCache, TaskListCache } from "./server/objects/TaskBeans.ts";
import { itemName, toastItemRemoved } from "./list/task_undo.ts";
import { ContactCache } from "./contact/ContactCache.ts";
import { checkEventLimitOntry, modalEventHardLimitReached } from "./calendar/calendarclean.ts";
import { downloadUrl, pickFileFromDevice } from "./lib/FileUtils.ts";
import fizapilib from "./server/fizapilib.ts";
import { sleep } from "./lib/Async.ts";
import { ServerError } from "./server/fizapilib.auto.ts";
import { HTTPError } from "./server/SRV.ts";

function handlePermissionFor(permissionName){
  var permission = FwDatas.getPermission(permissionName)

  //means that the permission does not exists
  //happens when switching of family, the new one is still not loaded
  //TODO make some test with KO_PREMIUM
  //TODO review all the getPermission stuff
  //we return true
  if(permission===permissionName){
    return true;
  }else if(permission!=='OK'){
    Html.trigger(null,"takepremium")
    return false;
  }else{
    return true;
  }
}

libLocation.setFilter((pageInfo)=>{
  switch(pageInfo.page){
    case 'budget.php':{
      return handlePermissionFor('budget');
    }
    case 'document.php':{
      return handlePermissionFor('filer');
    }
    case 'timetable.php':{
      return handlePermissionFor('timetable');
    }
    case 'mealplanner.php':{
      return handlePermissionFor('mealPlannerFlag');
    }
    case 'recipebox.php':{
      return handlePermissionFor('recipeBoxFlag');
    }
    case 'specialdays.php':{
      return handlePermissionFor('specialDays');
    }
  }
  return true;
})


actionMenu.register({
  feedaction(){
    var
      metaId = Html.getDomMetaId(this),
      object = FwDatas.get(metaId)||FwDatas.getWall(metaId),
      menu = [];

    if(object.rights.canDelete){
      menu.push({svg:Icons.ic_delete,onclick:this.getAttribute('data-action-delete'),i18nkey:'actions.delete','color':'var(--red)'})
    }
    if(object.rights.canUpdate){
      menu.push({svg:Icons.ic_edit,onclick:this.getAttribute('data-action-edit'),i18nkey:'actions.edit'})
    }

    return {menu}
  },
  taskmenu(){
    return {menu:[
      {svg:Icons.ic_edit,onclick:'taskedit',i18nkey:'task_details.button'},
      {svg:Icons.ic_delete,onclick:'taskdelete',i18nkey:'task_details.deletebutton',color:'var(--red)'}
      ]}
  },
  taskquantityedit(){
    const
      node = this,
      metaId = Html.getDomMetaId(node),
      task = FwDatas.get(metaId),
      content = quantityPicker({quantity:task.quantity,unit:task.unit});
    if(!task.editable){
      throw new NotAdminError();
    }
    return {
      content,
      //the stepper would otherwise fire one call per click
      onCancel(){
        const {quantity,unit} = content.value();
        if(quantity===task.quantity && unit===task.unit) return;
        node.textContent = formatQuantityUnit(quantity,unit);
        //the task details opened from the calendar is an occurrence: update the task itself
        ApiServer.taskupdate2({taskId:task.taskId,quantity,unit});
        amplify.publish("taskNeedRefresh");
      }
    }
  },
  eventcreate(){
    var menu :actionMenu.ActionMenuButton[] = [
      {svg:Icons.ic_add_event,onclick:'eventcreate',i18nkey:'labels.event'},
      {svg:Icons.ic_checkmark_circle,onclick:'taskedit',i18nkey:'labels.task'},
      {permission:"specialDays",svg:Icons.calendar.ic_calendar_star,onclick:'specialdayscreate',i18nkey:'labels.specialevent'},
      {permission:"mealPlannerFlag",svg:Icons.ic_meals,onclick:'mpmealcreate',i18nkey:'labels.meal'}
      ];
    
    menu.push({svg:Icons.ic_email,i18nkey:'actions.inbox',onclick:"aiinboxmodal",permission:"aiImport",beta:true})
    menu.push({svg:Icons.ic_attachment,i18nkey:'importcalendar.menuitem',onclick:"importcalendar"})

    return {menu}
  },

  async eventmenu(){
    var
      metaId = Html.getDomMetaId(this),
      theEvent = FwDatas.get(metaId)
    var menu = [];
    var isGoodPage = !theEvent.isTimetableEvent || window.location.toString().indexOf('timetable')>-1;

    if(theEvent.eventType==='BIRTHDAY_ACCOUNT'){
      if(FwDatas.getProfile(theEvent.accountId).isEditable){
        menu.push({svg:Icons.ic_edit,onclick:"modaluser|"+theEvent.accountId,i18nkey:'actions.editsourcebirthdate'})
      }
    }else if(theEvent.eventType==='BIRTHDAY'){
      await ContactCache.need()
      if(ContactCache.get(theEvent.refPersonId)?.editable){
        menu.push({svg:Icons.ic_edit,onclick:"contactedit|"+theEvent.refPersonId,i18nkey:'actions.editsourcebirthdate'})
      }
    }
    if(isGoodPage && theEvent.editable){
      menu.push({svg:Icons.ic_edit,onclick:"eventedit",i18nkey:'actions.edit'})
    }
    if(!theEvent.isBudgetEvent && !theEvent.isMealplannerEvent){
      menu.push({svg:Icons.ic_duplicate,onclick:"eventduplicate",i18nkey:'actions.copy'})
    }
    if(!theEvent.isBudgetEvent && !theEvent.isMealplannerEvent && !theEvent.isTimetableEvent && FwDatas.getFamilies().length>1){
      menu.push({svg:Icons.ic_duplicate_othercircle,onclick:"eventcopy",i18nkey:'actions.copytoanothercircle'})
    }
    if(isGoodPage && theEvent.editable){
      menu.push({svg:Icons.ic_delete,color:'var(--red)',onclick:"deleteevent",i18nkey:'actions.delete'})
    }
    if(OS.canShare){
      menu.push({svg:Icons.ic_send,onclick:"eventshare",i18nkey:'actions.share'})
    }
    menu.push({svg:Icons.ic_download,onclick:"eventdownload",i18nkey:'actions.save'})
    return {menu:menu}
  }
})

actionMenu.register({
  async useraddfield(){
    var
      [TPL_INPUT_DEVICE,TPL_INPUT_ADDRESS] = await Promise.all([
        import("./contact/input_device.mustache"),
        import("./contact/input_address.mustache")
      ]),
      form = (this as HTMLButtonElement).form,
      devices = ['MOBILE','EMAIL'].map(deviceType=>{
        var device = new ApiServer.types.IDevice({deviceType:deviceType})
        device.index = form.querySelectorAll('input[name$=".deviceType"]').length;
        return {
          i18nkey:device.label,
          clickFunction:()=>{
            let result = Html.setHtmlAtEnd(document.getElementById('extrafields'),TPL_INPUT_DEVICE,device)
            result[0].querySelector<HTMLInputElement>('input[type="text"]').focus()
          }
        }
      }),
      addresses = ['HOME'].map(placeType=>{
        var address = new ApiServer.types.IAddress({placeType:placeType})
        address.index = form.querySelectorAll('input[name$=".placeType"]').length;
        return {
          i18nkey:address.label,
          clickFunction:()=>{
            let result = Html.setHtmlAtEnd(document.getElementById('extrafields'),TPL_INPUT_ADDRESS,address)
            result[0].querySelector<HTMLInputElement>('input[type="text"]').focus()
          }
        }
      });

    return {
      menu:devices.concat(addresses)
    }
  }
})


  ApiServer.customimthreadlist = ApiServer.imthreadlist.prepare(null,false,function(threads){
    var
      unreadThread = threads.filter(function(thread) {
      return thread.isunRead();
    }).length;
    amplify.publish("notificationBullet","imunreadthread",unreadThread);

  });


  Handlebars.registerHelper('renderMessage',function(text,mode){
    var options = arguments[arguments.length-1];
    if(text){
      const div = document.createElement('div');
      div.textContent = text.trim();
      var result = renderurl.render(div.innerHTML,mode);
      if(options.fn && result.length){
        return options.fn(new Handlebars.SafeString(result));
      }else{
        return new Handlebars.SafeString(result);
      }
    }else{
      return "";
    }

  });

  amplify.subscribe("familyMemberSelected", function(event){
    document.querySelectorAll<HTMLElement>(".fw-avatar-menu").forEach(obj=>{
      var
        accId :string,
        onclick = obj.getAttribute("data-fw-onclick");
      if(onclick && onclick.indexOf("familybarselectmember")===0){
        accId = onclick.substring(onclick.indexOf('|')+1);
      }else{
        return;
      }
      var img = obj.querySelector('img')
      if(img){
        if(accId==event.selected){
          img.classList.add('border-branded')
          img.classList.remove('fw-border-white')
        }else{
          img.classList.remove('border-branded')
          img.classList.add('fw-border-white')
        }
      }

    })
  });

  amplify.subscribe ("memberUpdated", function(){
    modal.closeDomModal();
    libLocation.refresh();
  });
  amplify.subscribe ("refresh", function(){
    libLocation.refresh();
  });

export class NotAdminError extends Error{};  
export function notadminmodal(){
  modal.askAsPromise({
    title:'errors.oopsadminonly',
    lottie:"images/lottie/face_with_monocle.json",
    message:'errors.oopsadminonlytext',
    button:[{title:'actions.gotit'}]
  })
}
window.addEventListener('unhandledrejection', async event => {
  try{
    var e = event.reason;
    if(e instanceof NotAdminError) {
      notadminmodal()
      return;
    }
    if(e.handledrejection) return;
    else e.handledrejection = true;

    if(e instanceof ServerError){
      if(e.code==='611' || e.code==='610'){
        if(e.type==="folder"){
          return modal.oops(i18n.get('fw2.apierrors.611folder'))
        }else if(e.type==="media"){
          return modal.oops(i18n.get('fw2.apierrors.611file'))
        }
      }
    
    } 
    if(e instanceof HTTPError){
      ApiServer.webjslog = ()=>{};
      return modal.oops(i18n.get('fw2.defaultError'))
    }
    console.log(e);
    await sleep(1000)
    // There is something wrong with APiServer as sync call
    // if I don't set the errorHandler it is rejected and repass in this eventListener;
    if(e instanceof Error){
      await ApiServer.webjslog(FizConfig.VERSION + " "+window.location.pathname+" => unhandledrejection "+e+"\n"+e.stack);
    }else{
      await ApiServer.webjslog(FizConfig.VERSION + " "+window.location.pathname+" => unhandledrejection "+e);
    }

  }catch(ee){
    ApiServer.webjslog = ()=>{};
    ee.handledrejection = true;
    //we do not want to loop in this if the call causes error
    console.log(ee);
  }
});

Html.registerDom({
  async taskdelete(){
    const node = Html.getDomMetaIdNode(this);
    const domMetaId = Html.getDomMetaId(node);
    //a task opened from the calendar carries the id of one occurrence (taskId_N): delete the task itself
    const metaId = FwDatas.get(domMetaId)?.taskId || domMetaId;

    if(!await modal.confirmDelete('task_details.deleteconfirm')) return;

    modal.closeDomModal();
    //rows outside the task lists (feed, meal planner) are not rendered from the TaskCache
    const rows = [...document.querySelectorAll('[data-fw-meta-id="'+metaId+'"],[data-fw-meta-id^="'+metaId+'_"]')] as HTMLElement[];
    rows.forEach(el => el.style.display = 'none');

    const task = FwDatas.get(metaId);
    const deletion = TaskCache.deferDelete([metaId],()=>ApiServer.metadelete([metaId]));
    amplify.publish('taskNeedRefresh')
    toastItemRemoved(itemName(task?.text||'',task?.quantity,task?.unit),{
      ...deletion,
      undo(){
        deletion.undo();
        rows.forEach(el => el.style.display = '');
      }
    });
  },
  taskview(taskId){
    const node = Html.getDomMetaIdNode(this);
    let metaId = taskId || Html.getDomMetaId(node);
    let task = FwDatas.get(metaId);
    let currentModal : modal.DomModal;
    //if instance of task not in cache we display the main
    if(task==null){
      metaId = metaId.substring(0,metaId.lastIndexOf('_'))
      task = FwDatas.get(metaId)
    }
    import("./list/task_view.mustache").then(function(TPL){
      function ontaskChange(){
        ApiServer.loadTaskAndList(function(lists,listsById,tasks,tasksById,categoryList){
          var isDeleted = tasksById[task.taskId]===undefined;
          if(isDeleted){
            modal.closeDomModal(currentModal)
          }else{
            //the cache has been updated
            task = FwDatas.get(metaId);
            task.justChange = true;
            Html.setHtml(currentModal,TPL,task)
            
            task.justChange = undefined;
          }
        });

      }
      const amplifyEvents = {
        taskNeedRefresh:ontaskChange,
        mediaDeleted:ontaskChange
      }
      if(task && task.list){
        currentModal = modal.openDomModal(TPL,task,amplifyEvents);
      }else{
        ApiServer.loadTaskAndList(function(){
          currentModal = modal.openDomModal(TPL,FwDatas.get(metaId),amplifyEvents);
        });
      }


    });
  },
  taskedit(){
    //no meta id around when called from a create menu: a new task
    const metaId = Html.getDomMetaId(this);
    modal.closeDomModal();
    let task = FwDatas.get(metaId);
    if(task && task.taskId!==metaId){
      task = FwDatas.get(task.taskId)
    }
    import("./list/task_edit.mustache").then(function(TPL){
      ApiServer.loadTaskAndList(function(){
        if(!task){
          var lists = [].concat(TaskListCache.datas);
          lists.sort((a,b)=>b.lastActionDate - a.lastActionDate)
          task = new ApiServer.types.TaskInputBean({
            recurrency:'NONE',
            taskListId:lists[0].metaId,
            dueDate:(new Date()).toISOString()
          });
        }
        modal.openDomModal(TPL,{
          task:task
        });
      });
    });
  },
  taskmark(complete){
    let metaId = Html.getDomMetaId(this);

    if(metaId.indexOf('_',metaId.indexOf('_')+1)>-1){
      metaId = metaId.substring(0,metaId.indexOf('_',metaId.indexOf('_')+1))
    }
    const marked = ApiServer.taskmark.setOptions({progressbar:'none'})(metaId,complete);
    if(String(complete)==='true'){
      const taskListType = TaskListCache.get(FwDatas.get(metaId)?.taskListId)?.taskListType;
      Promise.resolve(marked).then(()=>segment.track("Task Completed",{list_type:segment.enumValue(taskListType)}));
    }
    amplify.publish("taskNeedRefresh")
    return false;
  },
  taskmarkimpossible(){
    modal.alert("task_details.markimpossible");
  },
  eventedit(){
    const metaId = Html.getDomMetaId(this);
    const event = FwDatas.get(metaId);
    if(event){
      calendar_modal.editEvent(event)
    }else{
      ApiServer.evtget(metaId,calendar_modal.editEvent);
    }
  },
  async eventduplicate(){
    if(!await checkEventLimitOntry()){
      modalEventHardLimitReached()
      return;
    }
    function doIt(original){
      var
        event = original.cloneWith({metaId:null});

      if(original.eventType==='EXTERNAL'){
        event.calendar = null;
        event.toAll = "true";
      }
      if(event.isTimetableEvent){
        event.calendar = original.calendar
      }else{
        let
          now = new Date();
        while(event.start<now){
          let start = new Date(event.start)
          let end = new Date(event.end)
          start.setDate(start.getDate()+7)
          end.setDate(end.getDate()+7)

          event.start = start
          event.end = end
        }
      }
      calendar_modal.editEvent(event);
    }

    const metaId = Html.getDomMetaId(this);
    const eventFromCache = FwDatas.get(metaId);
    if(eventFromCache){
      doIt(eventFromCache)
    }else{
      ApiServer.evtget(metaId,doIt);
    }
  },
  async eventcreate(){
    var
      start = new Date(),
      end = new Date();
    start.setMinutes(0)
    start.setHours(start.getHours()+1);
    end.setMinutes(0);
    end.setHours(start.getHours()+1);

    calendar_modal.createEvent(start,end,false);
  },

  async modaluser(userId){
    var member = FwDatas.getProfile(parseInt(userId));
    if(member.isAccountDeleted){
      modal.alert("editAccount.memberDeleted");
    }else{
      var TPL = await import("./modal/user_view.mustache")
      modal.openDomModal(TPL,member)
    }

  },
  async useraddemail(){
    var
      member = FwDatas.getProfile(FwDatas.getAccountId()),
      login = member.identifiers.find(identifier=>identifier.type==='Login')?.value;
    if(!login) return;
    var
      email = await modal.askIdentifierEmail({
        title:"enterEmailModal.title",
        emoji:"📧",
        message:i18n.get("enterEmailModal.description",login),
        placeholder:"enterEmailModal.placeholder",
        buttonName:"actions.next",
      });
    if(!email) return;
    var
      password = await modal.askCurrentPassword(login,{
        title:"confirmPasswordModal.title",
        emoji:"🔒",
        messageHTML:i18n.get("confirmPasswordModal.description")+` <a style="color:var(--fwPrimary);text-decoration:underline" data-fw-onclick="goto|settings.php?tab=settings_password">${i18n.get('actions.reset')}</a>`,
        placeholder:"********",
        buttonName:"actions.continue",
      });
    if(!password) return;

    try{
      await MultiplexApi.accaddidentifier2('Email',email,'',undefined,password)
      await modal.askAsPromise({
        title:"checkInboxModal.title",
        emoji:"📫",
        message:i18n.get("checkInboxModal.description",email),
        button:[{title:"actions.gotit"}],
      })
      libLocation.refresh()
    }catch(e){
      modal.oops("errors.oops")
    }


  },
  async modaluseredit(userId){
    var member = FwDatas.getProfile(parseInt(userId));
    var TPL = await import("./modal/user_edit.mustache")
    var editModal = modal.openDomModal(TPL,member);
    editModal.onCancel = modal.onCancelForm
  },
  selectplace(placeId){
    if(libLocation.getPageName()!='map.php'){
      libLocation.goTo('map.php?placeId='+placeId);
    }else{
      amplify.publish ("placeSelected", placeId);
    }
  },
  async userdeletemyself(userId){
    if(!await modal.confirmDelete("editAccount.confirmBeforeDeletingFamilyMember")) return;

    try{
      amplify.publish('familyChange')
      await ApiServer.adminremove(userId,false)
      await modal.alert("editAccount.familyMemberDeleted")

      for(let family of FwDatas.getFamilies()){
        if(family.metaId!==FwDatas.getFamily().metaId){
          multifamily.changeToFamily(family.metaId);
          return;
        }
      }
      login.logoutWantedByUser();
    }catch(e){
      if(e instanceof fizapilib.types.FizPremiumOngoingException){
        modal.alert({
          title:"fw2.error65.title",
          message:i18n.get("fw2.error65.message",new Date(e.subscriptionEndDate)),
          lottie:"images/lottie/anim_warning.json"
        });
      }else{
        throw e
      }
    }



  },
  async userdelete(userId){
    if(!await modal.confirmDelete("editAccount.confirmBeforeDeletingFamilyMember")) return;

    try{
      amplify.publish('familyChange')
      await ApiServer.adminremove(userId,false)
      segment.track("Family Member Removed");
      await libLocation.refresh()
      modal.alert("editAccount.familyMemberDeleted");
    }catch(e){
      if(e instanceof ApiServer.types.FizPremiumOngoingException){
        modal.alert({
          title:"fw2.error65.title",
          message:i18n.get("fw2.error65.message",new Date(e.subscriptionEndDate)),
          lottie:"images/lottie/anim_warning.json"
        });
      }else{
        throw e
      }
    }

  },
  zoomopen(){
    const zoomable = this.querySelector('.zoomable') as HTMLElement;
    if(!zoomable) return;
    zoomable.classList.add('zoomed');
    document.body.addEventListener('click',()=>{
      zoomable.classList.remove('zoomed');
    },{once:true})
  },
  createcirclequotareached(){
    modal.alert({title:"errors.createcirclequotareached",message:i18n.get("errors.createcirclequotareacheddetail",FwDatas.getState().premium.technicalLimiFamilies)});
  },
  invitequotareached(){
    modal.alert({title:"errors.invitequotareached",message:i18n.get("errors.invitequotareacheddetail",FizConfig.invitequota)});
  },
  gotoim(msgAccountId){
    libLocation.goTo("im.php?target="+msgAccountId);
  },


  selectmember(accountId){
    accountId = accountId||this.getAttribute("data-fw-meta-id")||FwDatas.getAccountId();
    amplify.publish ("familyMemberSelected", {selected: accountId});
  },
  familybarselectmember(accountId){
    accountId = accountId||this.getAttribute("data-fw-meta-id");
    amplify.publish ("familyMemberSelected", {selected: accountId,fromFamilybar:true});
    return false;
  },
  async metadelete(confirmTxt,amplifyEventName){
    const node = Html.getDomMetaIdNode(this);
    const id = Html.getDomMetaId(node);

    if(!await modal.confirmDelete(confirmTxt)) return;

    ApiServer.metadelete(id,function(){
      node.style.display = 'none';
      setTimeout(() => node.remove(), 400);
      if(amplifyEventName){
        amplify.publish(amplifyEventName,id);
      }
    });

  },
  async deleteevent(){
    const id = Html.getDomMetaId(this);
    const dbEvent = FwDatas.get(id);
    const currentModal = this.closest(".modal") as modal.DomModal;
    let options: string[];
    let option: string;

    // FWWEB-1805
    if(dbEvent.hasItsOwnRecurrency() && !document.querySelector('.manageimport-detail-events')){
      options = await ApiServer.evtdeleteoption(id);
    }else{
      options = ['All']
    }
    if(options.length<2){
      if(!await modal.confirmDelete("event.confirm_delete_event_popup")) return;
      option = options[0];
    }else{
      option = await modal.askAsPromise({
        title:'event.deleterecurringtitle',
        message:'event.deleterecurringtext',
        button:options.map(opt=>{return {value:opt,title:'event.deleterecurring'+opt}})
      })
    }
    if(option){
      //todo check without the await
      await ApiServer.evtdelete(option,[id]);
      segment.track("Calendar Event Deleted");
      amplify.publish("eventDeleted");
      if(currentModal){
        modal.closeDomModal(currentModal);
      }
    }

  },
  async deletetimetableevent(){
    const id = Html.getDomMetaId(this);
    const currentModal = this.closest(".modal") as modal.DomModal;

    if(!await modal.confirmDelete("event.confirm_delete_event_popup")) return;

    await ApiServer.evtdelete("All",id)
    amplify.publish("eventDeleted");
    if(currentModal){
      modal.closeDomModal(currentModal);
    }
  },
  async eventshare(){
    try{
      const metaId = Html.getDomMetaId(this);
      const event = FwDatas.get(metaId);
      const url = await ApiServer.evticalvisibleurl(false,event.calendarId,event.metaId);

      await navigator.share({url})
    }catch(e){
      modal.oops('fw2.defaultError')
    }

  },
  async eventdownload(){
    const metaId = Html.getDomMetaId(this);
    const event = FwDatas.get(metaId);
    const url = await ApiServer.evticalvisibleurl(false,event.calendarId,event.metaId)
    downloadUrl(url,event.title + ".ics")
  },
  alert(text){
    modal.alert(text);
  },
  notadminmodal

});


//end of expand controll


//start unstar and comment
ApiServer.modalmetaupdatetext = ApiServer.metaupdatetext.prepare(function(res){
  modal.closeDomModal();
  res.justUpdated = true;
  if(res instanceof ApiServer.types.IWallMessage){
    wallUiReturn(res);
  }else{
    amplify.publish("CommentChanged")
    commentUiReturn(res);
  }
});

function wallUiReturn(wallMessage){
  import("./feed/default.mustache").then(function(TPL_default){
    const feedNode = document.querySelector('#activity-feed div[data-fw-meta-id="'+wallMessage.id+'"]') as HTMLElement;
    if(feedNode) {
      Html.setHtml(feedNode, TPL_default, wallMessage);
    }
  })
}
function moodWallUiReturn(wallMessage){
  wallMessage.justMooded=true;
  wallUiReturn(wallMessage);
}
async function commentUiReturn(comment){
  var
    commentNodes = document.querySelectorAll<HTMLElement>('*[data-fw-meta-id="'+comment.commentId +'"]'),
    TPL_comment = await import("./comments/comment.mustache");
  commentNodes.forEach(commentNode=>{
     Html.replaceWithSingleDom(commentNode,TPL_comment,comment);
  })

}

Html.registerDom({
  async mediadownload(){
    //all this fetch stuff is for havong the toast disapearing when downloaded
    //then the true download is launched
    const
      url = FizConfig.API_BASE_URL+"mediadownload?id="+encodeURIComponent(Html.getDomMetaId(this)),
      toast = await modal.toast({emoji:'📁',text:'download.prepare'},0);
    try{
      const
        resp = await fetch(url,{credentials:"include"}),
        newUrl = URL.createObjectURL(await resp.blob()),
        fileName = resp.headers.get("X-File-Name");

      downloadUrl(newUrl,fileName)

      URL.revokeObjectURL(newUrl);

    }finally{
      toast.close()
    }


  },

  star(){
    const metaId = Html.getDomMetaId(this);
    ApiServer.wallmood.noPg()(metaId,["STAR"],moodWallUiReturn);
  },
  unstar(){
    const metaId = Html.getDomMetaId(this);
    ApiServer.wallmood.noPg()(metaId,[],["STAR"],moodWallUiReturn);


  },
  async metamood(val){
    const metaId = Html.getDomMetaId(this);
    if(val==='true'){
      ApiServer.metamood.noPg()(metaId,["STAR"],[]);
      document.querySelectorAll<HTMLElement>('*[data-fw-meta-id="'+metaId +'"] icon[data-fw-onclick^="metamood"]').forEach(icon=>{
        icon.classList.add('animated')
        icon.classList.add('bounceIn')
        icon.setAttribute('data-fw-onclick',"metamood|false")
        icon.innerHTML = Icons.ic_added_to_favorites.toString()
      })
      FwDatas.get(metaId).moodStarShortcut = true
    }else{
      ApiServer.metamood.noPg()(metaId,[],["STAR"]);
      document.querySelectorAll<HTMLElement>('*[data-fw-meta-id="'+metaId +'"] icon[data-fw-onclick^="metamood"]').forEach(icon=>{
        icon.classList.remove('animated')
        icon.classList.remove('bounceIn')
        icon.setAttribute('data-fw-onclick',"metamood|true")
        icon.innerHTML = Icons.ic_add_to_favorites.toString()
      })
      FwDatas.get(metaId).moodStarShortcut = false
    }




  },

  edittext(){
    const node = Html.getDomMetaIdNode(this);
    const id = Html.getDomMetaId(node);
    const type = id.substring(0,id.indexOf('/'));
    const titleKey = {wall:'edittext.note',wallComment:'edittext.comment'}[type]||'edittext.default';
    import("./modal/text_edit.mustache").then(function(TPL){
      modal.openDomModal(TPL,{title:titleKey,metaId:id,text:FwDatas.getWall(id).text});
    });
  },
  async copyprevchild(selector? :string){
    let nodeToCopy: HTMLElement = this;

    if(selector==='.'){
      //in this case we do not want the prev but the current
    }else{
      nodeToCopy = nodeToCopy.previousElementSibling as HTMLElement;
      if(nodeToCopy.firstElementChild){
        nodeToCopy = nodeToCopy.firstElementChild as HTMLElement
      }
    }
    this.style.backgroundColor = '#8ec549';
    this.style.transition = 'all ease 500ms';
    setTimeout(() => {
      this.style.backgroundColor = '';
    },500)
    await navigator.clipboard.writeText(nodeToCopy.innerText)
    modal.toast({text:'actions.copied',emoji:'👍'})

  }
});
ApiServer["custom.checkin"] = function(form,success,error){
  if(form.placeId.value!==''){
    ApiServer.locpublishplacelocation(form,success,error);
  }else{
    ApiServer.locpublishaddress(form,success,error);
  }
}
ApiServer.settingsfeedback = ApiServer.settingsfeedback.prepare(function(){
  modal.closeDomModal();
  modal.askAsPromise({
    title:'feedback.thanks',
    message:'feedback.thanksmessage',
    lottie:"images/lottie/hugging_face.json",
    button:[{title:'actions.close'}]
  })
})

export async function pickVerifiedFileFromDevice(accept,acceptPremium,isPremium,multiple = false){

  function verifyAccept(accept, file) {
    const mime = file.type;       // ex: "image/png"
    const ext  = "." + file.name.split(".").pop()?.toLowerCase();

    return accept
      .split(",")
      .map(part => part.trim().toLowerCase())
      .some(part => {
        if (part.endsWith("/*")) {
          // Cas "image/*" → comparer seulement le type principal
          return mime.startsWith(part.slice(0, -1));
        }
        if (part.startsWith(".")) {
          // Cas ".png" → comparer avec l'extension
          return ext === part;
        }
        // Cas "image/png"
        return mime === part;
      });
  }

  var files = await pickFileFromDevice(isPremium?acceptPremium:accept,multiple)
  //si on a des truc non acceptable on les vire
  files = files.filter(file=>verifyAccept(acceptPremium,file))
  if(!isPremium){
    if(files.some(file=>!verifyAccept(accept, file))){
      Html.trigger(null,'takepremium')
      return []
    }
  }
  return files;
}
